import { Component, model } from '@angular/core';
import { RxIconModule } from '@nrwl/rx-icon';

@Component({
  selector: 'fb-expansion-panel',
  imports: [RxIconModule],
  templateUrl: './expansion-panel.html',
  styleUrl: './expansion-panel.scss',
  host: { '[attr.data-expanded]': 'expanded()' },
})
export class ExpansionPanel {
  /**
   * Whether the expansion panel is expanded.
   */
  public readonly expanded = model(false);

  /**
   * Toggles the expansion panel.
   */
  protected toggle() {
    this.expanded.update((expanded) => !expanded);
  }
}
